import React from 'react'
import Link from 'gatsby-link'
import styled, { injectGlobal } from 'styled-components'
import Logo from './logo'
import Navigation from './navigation'

const HeaderWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem;

  @media (min-width: 40em) {
    margin: 2rem;
  }
`

const Header = ({ pages, path, language }) => {
  return (
    <HeaderWrapper>
      <Logo currentLanguage={language} />
      <Navigation pages={pages} currentPath={path} currentLanguage={language} />
    </HeaderWrapper>
  );
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js